<template>
  <vs-popup
    class="popup"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="w-full flex justify-between items-center">
      <h3 class="title-content">
        Return Cargo - {{ tripNumber }}
      </h3>
      <img
        class="button-close"
        :src="require('@/assets/shipo-popup-icon-close.svg')"
        @click="closeModal"
      >
    </div>
    
    <div
      id="detailContainer"
      class="w-full mt-3 vs-con-loading__container overflow-auto"
    >
      <p class="px-5 text-center">
        This will update and generate return cargo trip for {{ tripNumber }}.
        This action cannot be undone.
      </p>
      <hr class="border-dashed my-4">
      <vs-row
        vs-w="12"
      >
        <vs-col vs-w="6">
          <div class="w-full mb-2 px-2">
            <label class="block mb-2 font-medium">Actual Cargo</label>
            <template>
              <div class="vs-input w-full">
                <v-autonumeric
                  v-model="form.actual_cargo"
                  placeholder="Enter actual cargo"
                  :class="{ 'is-not-valid': !form.actual_cargo }"
                  class="vs-input--input"
                  :disabled="false"
                  :options="globalNumericOptions"
                />
              </div>
              <div v-if="!form.actual_cargo">
                <span
                  class="text-danger text-sm absolute-bottom-5 left-0"
                >*Required</span>
              </div>
            </template>
          </div>
        </vs-col>
        <vs-col vs-w="6">
          <div class="w-full mb-2 px-2">
            <label class="block mb-2 font-medium">Remaining Cargo</label>
            <template>
              <div class="vs-input w-full">
                <v-autonumeric
                  v-model="form.remaining_cargo"
                  placeholder="Enter remaining cargo"
                  :class="{ 'is-not-valid': !form.remaining_cargo }"
                  class="vs-input--input"
                  :disabled="false"
                  :options="globalNumericOptions"
                />
              </div>
              <div v-if="!form.remaining_cargo">
                <span
                  v-if="!form.remaining_cargo"
                  class="text-danger text-sm absolute-bottom-5 left-0"
                >*Required</span>
              </div>
            </template>
          </div>
        </vs-col>
        <vs-col
          vs-w="12"
          class="mb-2 px-2"
        >
          <label class="block mb-2 font-medium">End User</label>
          <div>
            <select-with-search
              v-model="form.vessel_line_up_id"
              :class="{ 'is-not-valid': !form.vessel_line_up_id }"
              :options="endUserOptions"
              placeholder="End User"
              :disabled="false"
              style="max-height: 200px"
              bottom
            />
          </div>
          <span
            v-if="!form.vessel_line_up_id"
            class="text-danger text-sm absolute-bottom-5 left-0"
          >*Required</span>
        </vs-col>
        <vs-col
          vs-w="6"
          class="mb-2 px-2"
        >
          <label class="block mb-2 font-medium">Vessel</label>
          <div class="mt-3 min-w-full flex align-items-center">
            {{
              endUserOptions.length && form.vessel_line_up_id
                ? endUserOptions.find(v => v.value === form.vessel_line_up_id).vessel_name
                : '-'
            }}
          </div>
        </vs-col>
        <vs-col
          vs-w="6"
          class="mb-2 px-2"
        >
          <label class="block mb-2 font-medium">POD</label>
          <div class="mt-3 min-w-full flex align-items-center">
            {{
              endUserOptions.length && form.vessel_line_up_id
                ? endUserOptions.find(v => v.value === form.vessel_line_up_id).pod
                : '-'
            }}
          </div>
        </vs-col>
      </vs-row>
      <div class="h-10" />
      <div class="flex justify-between mt-3">
        <vs-button
          type="border"
          color="primary"
          class="w-1/2 mr-2 button"
          @click="closeModal"
        >
          Cancel
        </vs-button>
        <vs-button
          class="w-1/2 button shadow-primary"
          color="primary"
          @click="onHandleSubmit"
        >
          {{ isAdd ? 'Create Return Cargo' : 'Save Change' }}
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import _, { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'

import SelectWithSearch from '@/components/selectWithSearch'

export default {
  name: 'ModalReturnCargo',
  props: {
    bluId: {
      type: Number,
      default: () => null
    },
    tripNumber: {
      type: String,
      default: () => null
    },
    isAdd: {
      type: Boolean,
      default: () => true
    }
  },
  components: {
    SelectWithSearch
  },
  computed: {
    ...mapGetters({
      dropdownOptions: 'BargeLineUp/dropdownOptionsBLU'
    })
  },
  watch: {
    bluId: {
      deep: true,
      handler(val) {
        if (val) {
          this.fetchEndUserOptions(val)
        }
      }
    },
    dropdownOptions: {
      handler(val) {
        if (val) {
          this.endUserOptions = val.map(opt => ({
            value: opt.id,
            text: opt.end_user,
            pod: opt.pod,
            vessel_name: opt.vessel_name
          }))
        }
      }
    },
    isLoading: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$vs.loading({
            type: 'radius',
            color: 'primary',
            container: '#detailContainer',
            scale: 0.5
          })

          return
        }

        this.$vs.loading.close('#detailContainer > .con-vs-loading')
      }
    }
  },
  data() {
    return {
      isLoading: false,
      endUserOptions: [],
      form: {
        actual_cargo: 0,
        remaining_cargo: 0,
        vessel_line_up_id: null
      }
    }
  },
  methods: {
    async fetchEndUserOptions(id) {
      await this.$store.dispatch('BargeLineUp/getDropdownOptionsBLU', {
        type: 'RETURN_CARGO_VLU',
        blu_id: id
      })
    },
    async onHandleSubmit() {
      try {
        this.isLoading = true

        if (this.validateForm(this.form)) {
          this.isLoading = false
          this.showFailedNotification(this, 'Some field is empty, please fill it first')
          return
        }

        if (this.isAdd) {
          await this.$store.dispatch('BargeLineUp/postReturnCargo', {
            id: this.bluId,
            form: this.form
          })
          this.showSuccessNotification(this, 'Return Cargo successfully added.')
        } else {
          await this.$store.dispatch('BargeLineUp/putReturnCargo', {
            id: this.bluId,
            form: this.form
          })
          this.showSuccessNotification(this, 'Return Cargo successfully updated.')
        }

        this.closeModal()
      } catch ({ error }) {
        this.isLoading = false
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    validateForm(form) {
      return _.some(form, (value, key) => {
        if (['actual_cargo', 'remaining_cargo'].includes(key)) {
          return _.isNil(value) || value === '' || value === 0;
        }

        if (key === 'vessel_line_up_id') {
          return _.isNil(value) || value === '';
        }

        return _.isNil(value) || value === '';
      });
    },
    closeModal() {
      this.$emit('action')
      this.form = this.$options.data().form
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;
    width: 30rem;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-4;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
      z-index: 2;
    }

    &--title-on-top {
      @apply absolute;
      width: 90%;
      top: 1.5rem;
      left: 1rem;
      font-weight: 600;
      font-size: 1.5rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}

.title-content {
  font-weight: 600;
  font-size: 1.5rem;
}

.button-close {
  @apply cursor-pointer;
  width: 35px;
}
</style>
